import { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react'
import { TextField } from '@mui/material'

interface TypeBodyAreaProps {
    value: string
    _key: string
    onBlur?: (text: string) => void
}

const TypeBodyAreaField = ({ value, _key, onBlur }: TypeBodyAreaProps) => {
    const [content, setContent] = useState<string | undefined>(value)

    const [isFocused, setIsFocused] = useState(false)
    const editorRef = useRef(null)

    const handleFocus = () => setIsFocused(true)
    const handleBlur = () => setIsFocused(false)

    const OnBlurEvent = useCallback(
        (value: string | undefined) => {
            setContent(value)
            if (onBlur === undefined) {
                return
            }
            onBlur(value ?? '')
        },
        [onBlur],
    )

    function OnChangeEvent(
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ): void {
        setContent(event.target.value)
    }

    useEffect(() => {
        if (!isFocused) {
            // The onBlur event logic goes here
            OnBlurEvent(content)
        }
    }, [OnBlurEvent, content, isFocused])

    return (
        <div
            ref={editorRef}
            onFocus={handleFocus}
            onBlur={handleBlur}
            tabIndex={0} // Make the div focusable
            data-color-mode='light'
        >
            <div className='wmde-markdown-var'> </div>
            <TextField
                key={_key}
                id={_key}
                value={content}
                onChange={OnChangeEvent}
                multiline={true}
                minRows={6}
                fullWidth={true}
                sx={{background:'#FBFBFB'}}
            />
        </div>
    )
    //      <TextArea aria-label="minimum height" minRows={3}  />
    //<img src={isDynamic?"/dynamic.png":"/fix.png"} style={{width:20,height:20}} alt={isDynamic?"dynamic":"fix"} onClick={()=>{setIsDynamic(isDynamic?false:true)}}/>
}

export default TypeBodyAreaField
